import React from "react";
import { Spinner } from "react-rainbow-components";
import {
  BubleEdit,
  CardCoupon,
  Container,
  ContainerContent,
  ContainerCoupon,
  ContainerListUser,
  ContentCoupon,
  HeaderTitle,
} from "./index.style";
import { FaShoppingBasket } from "react-icons/fa";
import { MdAdd, MdDelete } from "react-icons/md";
import { ICoupon } from "../../interfaces/coupon";
import CouponDetail from "../../components/couponSettingComponent/CouponDetail";
import ModalCreateCoupon from "../../components/couponSettingComponent/ModalCreateCoupon";
import ModalConfirmation from "../../components/common/ModalConfirmation";
import { IUser } from "../../interfaces/user";
import { deleteCoupon, getAllCoupons } from "../../services/coupon.service";
import { GetErrorMessage } from "../../functions/error";
import { useError } from "../../store/ErrorModal";
import { getAllUser } from "../../services/user.service";

function CouponSettingPage() {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [coupon, setCoupon] = React.useState<ICoupon>();
  const [data, setData] = React.useState<ICoupon[]>([]);
  const [isOpenDelete, setIsOpenDelete] = React.useState<boolean>(false);
  const [deleteId, setDeleteId] = React.useState<string>();
  const [allUser, setAllUser] = React.useState<IUser[]>();
  const { onError } = useError();
  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await deleteCoupon(deleteId);
      setIsOpenDelete(false);
      fetchData();
    } catch (error) {
      onError(GetErrorMessage(error));
    }
  };
  //   const handalClickCreateProduct = () => setIsOpen(true);
  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getAllCoupons();
      const user = await getAllUser();
      setAllUser(user.data);
      setData(res.data);
    } catch (error) {
      onError(GetErrorMessage(error));
    }
    setIsLoading(false);
  }, [onError]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  React.useEffect(() => {
    if (deleteId) setIsOpenDelete(true);
  }, [deleteId]);

  return !isLoading ? (
    <Container>
      <ModalCreateCoupon
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        fetchData={fetchData}
      />
      <HeaderTitle style={{ width: "100%" }}>
        <FaShoppingBasket size="2rem" />
        <h1>จัดการคูปอง</h1>
      </HeaderTitle>
      <ContainerContent>
        <ContainerCoupon>
          <CardCoupon>
            <ContentCoupon
              onClick={() => setIsOpen(true)}
              style={{ border: "none" }}
            >
              <h3 className="text-h-color">สร้างคูปอง</h3>
              <BubleEdit>
                <MdAdd size={128} color="#555" />
              </BubleEdit>
              <p className="text-h-color">เพิ่มคูปอง</p>
            </ContentCoupon>
          </CardCoupon>
          {data.map((item) => (
            <CardCoupon key={item.couponId}>
              <ContentCoupon
                onClick={() => setCoupon(item)}
                className={coupon?.couponId === item.couponId ? "active" : ""}
              >
                <h5>{item.productName}</h5>
                <BubleEdit onClick={() => setDeleteId(item.couponId)}>
                  <MdDelete size={22} color="#555" />
                </BubleEdit>
                <p className="text-h-color">{item.productDescription}</p>
              </ContentCoupon>
            </CardCoupon>
          ))}
        </ContainerCoupon>
        <ContainerListUser>
          {coupon && <CouponDetail coupon={coupon} allUser={allUser} />}
        </ContainerListUser>
      </ContainerContent>
      <ModalConfirmation
        isOpen={isOpenDelete}
        onConfirm={handleDelete}
        onCancel={() => {
          setIsOpenDelete(false);
          setDeleteId(undefined);
        }}
        title={"ยืนยันการลบคูปอง"}
        description={`ยืนยันการลบคูปอง`}
      />
    </Container>
  ) : (
    <div>
      <Spinner size="large" variant="brand" />
    </div>
  );
}

export default CouponSettingPage;
